import { render, staticRenderFns } from "./NotificationsMenu.vue?vue&type=template&id=142964d5&scoped=true"
import script from "./NotificationsMenu.vue?vue&type=script&lang=js"
export * from "./NotificationsMenu.vue?vue&type=script&lang=js"
import style0 from "./NotificationsMenu.vue?vue&type=style&index=0&id=142964d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142964d5",
  null
  
)

export default component.exports